import PropTypes from 'prop-types';
import {MultiLanguageFieldGroup} from '@/components/molecules';
import PepIrisImageReviewRow from './PepIrisImageReviewRow';
import ReviewField from './ReviewField';
import {toYesNo} from './reviewHelpers';

const GuidelineRows = ({guidelines, languages}) =>
  guidelines.map((row, index) => (
    <MultiLanguageFieldGroup
      key={row.id || index}
      className='pepiris-review-grid mt-4'
      languages={languages}
      dataTestId={`pepiris-review-guideline-${index}`}
      renderField={(lang) => (
        <ReviewField
          label={`Guideline ${index + 1}`}
          value={row.content?.[lang.code]?.text}
        />
      )}
    />
  ));

GuidelineRows.propTypes = {
  guidelines: PropTypes.array,
  languages: PropTypes.array
};

const PepIrisDisplayReview = ({formData = {}, languages = []}) => {
  const display = formData?.pepirisDisplay || {};
  const targetGuidelines = display.targetGuidelines || [];
  const photoGuidelines = display.photoGuidelines || [];

  return (
    <div className='flex flex-col gap-6' data-testid='pepiris-display-review'>
      <div className='ml-4'>
        <p className='review-section-label mb-3'>Target Card Images</p>
        <hr className='mb-4 border-[color:var(--color-border-divider)]' />
        <div className='pepiris-review-grid'>
          <PepIrisImageReviewRow
            label='Target Banner Image'
            image={display.bannerImage}
            testId='pepiris-review-banner-image'
          />
          <PepIrisImageReviewRow
            label='Target Card Thumbnail'
            image={display.thumbnailImage}
            testId='pepiris-review-thumbnail-image'
          />
        </div>
      </div>

      <div className='ml-4'>
        <p className='review-section-label mb-3'>Banner Text</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <MultiLanguageFieldGroup
          className='pepiris-review-grid'
          languages={languages}
          dataTestId='pepiris-review-banner-text'
          renderField={(lang) => {
            const data = display.bannerText?.[lang.code] || {};
            return (
              <>
                <ReviewField label='Title' value={data.title} />
                <ReviewField label='Description' value={data.description} />
              </>
            );
          }}
        />
      </div>

      <div className='ml-4'>
        <hr
          className='mb-2 border-[color:var(--color-border-divider)]'
          data-testid='pepiris-review-target-guidelines-divider'
        />
        <div data-testid='pepiris-review-target-guidelines'>
          <ReviewField
            label='Target Guidelines'
            value={toYesNo(display.targetGuidelinesEnabled)}
          />
        </div>
        {display.targetGuidelinesEnabled && (
          <GuidelineRows guidelines={targetGuidelines} languages={languages} />
        )}
      </div>

      <div className='ml-4'>
        <hr
          className='mb-2 border-[color:var(--color-border-divider)]'
          data-testid='pepiris-review-photo-guidelines-divider'
        />
        <div data-testid='pepiris-review-photo-guidelines'>
          <ReviewField
            label='Photo Guidelines'
            value={toYesNo(display.photoGuidelinesEnabled)}
          />
        </div>
        {display.photoGuidelinesEnabled && (
          <GuidelineRows guidelines={photoGuidelines} languages={languages} />
        )}
      </div>
    </div>
  );
};

PepIrisDisplayReview.propTypes = {
  formData: PropTypes.object,
  languages: PropTypes.array
};

export default PepIrisDisplayReview;
